import { useState, useEffect } from "react";
import LoadData from "./save-load/LoadData";
import StandardSubSettings from "./SettingsComponents/StandardSubSettings";
import TrafikverketInfo from "./TrafikverketInfo";
import { Typography } from "antd";

const Trafikverket = ({
  settings,
  isMobile,
  apiAdd,
  setHaveNewData,
  time,
  callback,
}) => {
  const settingsData = StandardSubSettings(settings, "Trafikverket");

  const [finalData, setFinalData] = useState([]);
  const [initial, setInitial] = useState(true);

  let useLocation = settingsData.useLocation;
  const location = LoadData("Location");
  let maxDistance = settingsData.maxDistance * 1000;
  const [trafficData, setTrafficData] = useState([]);

  function APIcall() {
    const fetch = require("node-fetch");

    async function fetchData() {
      const request1 =
        "<REQUEST>" +
        "<LOGIN authenticationkey='07fcff828ad64ffab2b9ea8056cc8388' />" +
        "<QUERY objecttype='Situation' schemaversion='1.2' orderby='Deviation.SeverityCode desc'>" +
        "<FILTER>" +
        "<IN name='Deviation.MessageType' value='Olycka,Viktig trafikinformation' />" +
        "</FILTER>" +
        "<INCLUDE>Deviation.CountyNo</INCLUDE>" +
        "<INCLUDE>Deviation.Id</INCLUDE>" +
        "<INCLUDE>Deviation.CreationTime</INCLUDE>" +
        "<INCLUDE>Deviation.Creator</INCLUDE>" +
        "<INCLUDE>Deviation.EndTime</INCLUDE>" +
        "<INCLUDE>Deviation.Geometry.WGS84</INCLUDE>" +
        "<INCLUDE>Deviation.LocationDescriptor</INCLUDE>" +
        "<INCLUDE>Deviation.Message</INCLUDE>" +
        "<INCLUDE>Deviation.MessageType</INCLUDE>" +
        "<INCLUDE>Deviation.NumberOfLanesRestricted</INCLUDE>" +
        "<INCLUDE>Deviation.RoadNumber</INCLUDE>" +
        "<INCLUDE>Deviation.SeverityText</INCLUDE>" +
        "<INCLUDE>PublicationTime</INCLUDE>" +
        "</QUERY>" +
        "</REQUEST>";

      const request2 =
        "<REQUEST>" +
        "<LOGIN authenticationkey='07fcff828ad64ffab2b9ea8056cc8388' />" +
        "<QUERY objecttype='Situation' schemaversion='1.2' orderby='Deviation.SeverityCode desc'>" +
        "<FILTER>" +
        "<IN name='Deviation.MessageType' value='Olycka,Viktig trafikinformation' />" +
        "<NEAR name='Deviation.Geometry.WGS84' value='" +
        location.longitude.toString() +
        " " +
        location.latitude.toString() +
        "' mindistance='0m' maxdistance='" +
        maxDistance +
        "m'/>" +
        "</FILTER>" +
        "<INCLUDE>Deviation.CountyNo</INCLUDE>" +
        "<INCLUDE>Deviation.CreationTime</INCLUDE>" +
        "<INCLUDE>Deviation.Id</INCLUDE>" +
        "<INCLUDE>Deviation.Creator</INCLUDE>" +
        "<INCLUDE>Deviation.EndTime</INCLUDE>" +
        "<INCLUDE>Deviation.Geometry.WGS84</INCLUDE>" +
        "<INCLUDE>Deviation.LocationDescriptor</INCLUDE>" +
        "<INCLUDE>Deviation.Message</INCLUDE>" +
        "<INCLUDE>Deviation.MessageType</INCLUDE>" +
        "<INCLUDE>Deviation.NumberOfLanesRestricted</INCLUDE>" +
        "<INCLUDE>Deviation.RoadNumber</INCLUDE>" +
        "<INCLUDE>Deviation.SeverityText</INCLUDE>" +
        "<INCLUDE>PublicationTime</INCLUDE>" +
        "</QUERY>" +
        "</REQUEST>";

      let xmlRequest = null;

      if (useLocation === true) {
        xmlRequest = request2;
      } else {
        xmlRequest = request1;
      }

      let response = await fetch(
        "https://api.trafikinfo.trafikverket.se/v2/data.json",
        {
          method: "post",
          body: xmlRequest,
        }
      );
      const json = await response.json();
      return json;
    }

    fetchData().then((r) => {
      setTrafficData(r.RESPONSE.RESULT[0].Situation);
    });
  }

  useEffect(() => {
    APIcall();
    const interval = setInterval(APIcall, 65000);
    return () => clearInterval(interval);
  }, []);

  let valueArray = [];

  function TrafikHaveNewDataCallback(value) {
    valueArray.push(value);

    if (valueArray.includes(true)) {
      setHaveNewData(true);
    } else {
      setHaveNewData(false);
    }
  }

  const sendInfo = () => {
    if (trafficData[0] != null) setInitial(false);

    //console.log("This is alert data: " + JSON.stringify(alertData))
    if (trafficData[0] != null) {
      trafficData.forEach((value, index) => {
        const dateFormated = value.PublicationTime.replace("latest_update ", "")
          .replaceAll(new RegExp(/\.\d*\+/, "gm"), "")
          .replaceAll("-", "")
          .replaceAll("T", "")
          .replaceAll(":", "");
        console.log("Formated date: " + dateFormated);
        const time = new Date(value.PublicationTime.slice(0, 19));
        setFinalData((finalData) => [
          ...finalData,
          {
            idArray: 4,
            id: value.Deviation[0].Id,
            key: index,
            headline: value.Deviation[0].Message,
            time:
              time.getDate() +
              "/" +
              (time.getMonth() + 1) +
              " kl " +
              time.getHours() +
              ":" +
              time.getMinutes() +
              ":" +
              time.getSeconds(),
            road: value.Deviation[0].RoadNumber,
            severity: value.Deviation[0].SeverityText,
            location: value.Deviation[0].LocationDescriptor,
            position: value.Deviation[0].Geometry.WGS84,
            callback: TrafikHaveNewDataCallback,
            settings: settingsData,
            notification: settingsData.notification,
            isoTime: value.PublicationTime.slice(0, 19),
          },
        ]);
      });
    }
  };

  useEffect(() => {
    if (isMobile === "true") apiAdd(finalData);
  }, [finalData]);

  useEffect(() => {
    if (initial && isMobile === "true") {
      console.log("attempt");
      sendInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trafficData]);

  var apiData =
    trafficData &&
    trafficData.map((value, index) => {
      const time = new Date(value.PublicationTime.slice(0, 19));
      return (
        <>
          {isMobile === "true" ? (
            <></>
          ) : (
            <TrafikverketInfo
              key={index}
              id={value.Deviation[0].Id}
              headline={value.Deviation[0].Message}
              time={
                time.getDate() +
                "/" +
                (time.getMonth() + 1) +
                " kl " +
                time.getHours() +
                ":" +
                time.getMinutes() +
                ":" +
                time.getSeconds()
              }
              road={value.Deviation[0].RoadNumber}
              severity={value.Deviation[0].SeverityText}
              location={value.Deviation[0].LocationDescriptor}
              position={value.Deviation[0].Geometry.WGS84}
              callback={TrafikHaveNewDataCallback}
              settings={settings}
              notification={settingsData.notification}
              isoTime={value.PublicationTime.slice(0, 19)}
            />
          )}
        </>
      );
    });

  var empty = apiData.length === 0;

  return (
    <>
      {empty ? (
        <>
          {isMobile === "true" ? (
            <></>
          ) : (
            <>
              <Typography.Title level={5} className="tileHeader">
                Inget att visa med dina nuvarande inställningar
              </Typography.Title>
            </>
          )}
        </>
      ) : (
        <>{apiData}</>
      )}
    </>
  );
};
export default Trafikverket;
